import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/zoom';
import Swiper from 'swiper';
import { EffectFade, Keyboard, Mousewheel, Navigation, Pagination, Thumbs, Zoom } from 'swiper/modules';
import { commonUtils } from './common_utils';

const fullscreenEventNames = [
    'fullscreenchange',
    'webkitfullscreenchange',
    'mozfullscreenchange',
    'MSFullscreenChange',
];

const fullscreenChangeHandler = function () {
    if (!commonUtils.fullscreen.isActive() && $('body').hasClass('swiper-large-image-visible')) {
        $('body').removeClass('swiper-large-image-visible');
        $('.swiperLarge').hide();
        const fullscreenSwiper = $('.swiperLarge:visible')[0]?.swiper;
        fullscreenSwiper?.keyboard?.enable();
    }
};
export const reviewImageSlider = {
    init() {
        this.bindEvents();
    },
    bindEvents() {
        const $body = $('body');
        let swiperLarge = null;

        $body.on('click', '.swiperLargeFullscreenImage', function (_e) {
            // Find the corresponding fullscreen slider for this ad
            const $fullscreenSlider = $(`.swiperLarge[data-review-id="${$(this).data('review-id')}"]`);

            if ($fullscreenSlider[0]) {
                commonUtils.fullscreen.open($fullscreenSlider[0]);
            }

            $fullscreenSlider.show();
            $body.addClass('swiper-large-image-visible');

            // Destroy existing fullscreen swiper instance if it exists
            const swiperLargeEl = $fullscreenSlider[0];
            if (swiperLargeEl && swiperLargeEl.swiper) {
                swiperLargeEl.swiper.destroy(true, true);
            }

            // Get the image count to conditionally enable loop
            const imageCount = $fullscreenSlider.find('.swiper-slide').length;

            // Initialize fullscreen Swiper with navigation, pagination, keyboard, and zoom
            swiperLarge = new Swiper($fullscreenSlider[0], {
                modules: [Navigation, Pagination, Thumbs, EffectFade, Keyboard, Zoom, Mousewheel],
                loop: imageCount > 1, // Only enable loop if there's more than one image
                speed: 0,
                mousewheel: {
                    sensitivity: 1.2, // More responsive than 0.3
                    thresholdDelta: 5, // Lower threshold for quicker response
                    thresholdTime: 250,
                },
                zoom: {
                    minRatio: 1,
                    maxRatio: 3,
                    toggle: true,
                    containerClass: 'swiperZoomContainer',
                },
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                pagination: {
                    el: $fullscreenSlider.find('.swiper-pagination-large')[0],
                    type: 'custom',
                    renderCustom(swiper, current, total) {
                        return `${current}/${total}`;
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next-large',
                    prevEl: '.swiper-button-prev-large',
                    addIcons: false,
                },
                on: {
                    init() {
                        // Store the swiper instance for later reference
                        $fullscreenSlider[0].swiper = this;
                    },
                    beforeDestroy() {
                        this.zoom.out();
                    },
                },
            });

            // Add fullscreen change listeners using stable reference
            fullscreenEventNames.forEach((fullScreenEvent) =>
                document.addEventListener(fullScreenEvent, fullscreenChangeHandler)
            );

            // Apply custom changes for scroll + laptop touch-pad pinch zoom
            // Detect pinch/zoom gestures
            if (swiperLarge) {
                let isPinching = false;

                ['gesturestart', 'gestureend'].forEach((eventType) => {
                    swiperLarge.el.addEventListener(
                        eventType,
                        (e) => {
                            e.preventDefault();
                            isPinching = eventType === 'gesturestart';
                        },
                        { passive: false }
                    );
                });

                // Handle wheel events
                swiperLarge.el.addEventListener(
                    'wheel',
                    (e) => {
                        // If it's a zoom gesture (Ctrl/Cmd + wheel or during pinch)
                        if (isPinching || e.ctrlKey || e.metaKey) {
                            // Let the zoom behavior happen naturally
                            swiperLarge.mousewheel.disable();
                            return;
                        }

                        // Re-enable mousewheel if we're not zooming
                        if (!swiperLarge.mousewheel.enabled) {
                            swiperLarge.mousewheel.enable();
                        }
                    },
                    { passive: true }
                );
            }

            // Add event listener for Escape key to close the fullscreen slider
            const handleEscKey = function (event) {
                if (event.key === 'Escape' || event.keyCode === 27) {
                    reviewImageSlider.closeFullscreen($fullscreenSlider);
                    $(document).off('keydown', handleEscKey);
                }
            };
            $(document).on('keydown', handleEscKey);

            return false;
        });

        // Close fullscreen slider when clicking the close button
        $body.on('click', '.swiperLargeViewClose', function () {
            if (commonUtils.fullscreen.isActive()) {
                commonUtils.fullscreen.exit();
            }

            $('.swiperLarge').hide();
            $body.removeClass('swiper-large-image-visible');

            fullscreenEventNames.forEach((fullScreenEvent) =>
                document.removeEventListener(fullScreenEvent, fullscreenChangeHandler)
            );

            // Also trigger the keydown event handler removal
            document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27 }));
        });
    },
    closeFullscreen($swiperFullScreen) {
        fullscreenEventNames.forEach((fullScreenEvent) =>
            document.removeEventListener(fullScreenEvent, fullscreenChangeHandler)
        );

        if (commonUtils.fullscreen.isActive()) {
            commonUtils.fullscreen.exit();
        }

        // Hide fullscreen slider and clear body state
        $('body').removeClass('swiper-large-image-visible');
        $swiperFullScreen.hide();
    },
};
